// @ts-ignore

import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from './store';

export const createAppAsyncThunk = <Returned, ThunkArg = void>(
	typePrefix: string,
	payloadCreator: (
		arg: ThunkArg,
		thunkAPI: {
			dispatch: AppDispatch;
			getState: () => RootState;
			extra: unknown;
			requestId: string;
			signal: AbortSignal;
			rejectWithValue: (value: unknown) => any;
		}
	) => Promise<Returned> | Returned
) => {
	return createAsyncThunk<Returned, ThunkArg, { state: RootState; dispatch: AppDispatch }>(
		typePrefix,
		payloadCreator
	);
};
